import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { bool, func, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const ConsentDialog = ({ open, documentName, onAccept, onBack }) => {
  const handleAccept = () => {
    onAccept({
      consentTimestamp: new Date().toISOString(),
      documentViewed: true,
      acceptanceMethod: 'button_click',
    });
  };

  return (
    <Dialog open={open} onClose={onBack} maxWidth="sm" fullWidth hideBackdrop>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LockOutlinedIcon sx={{ fontSize: 20, color: 'primary.main' }} />
          <span>{I18n.t('OmmnioSign.Consent.Title')}</span>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={theme => ({
          minWidth: 400,
          [theme.breakpoints.down('sm')]: {
            minWidth: 'auto',
          },
        })}
      >
        <Typography variant="body1" sx={{ mt: 3, lineHeight: 1.7 }}>
          <span
            dangerouslySetInnerHTML={{
              __html: I18n.t('OmmnioSign.Consent.ConsentText', { documentName }),
            }}
          />
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onBack}>{I18n.t('Common.Back')}</Button>
        <Button variant="contained" color="primary" onClick={handleAccept}>
          {I18n.t('OmmnioSign.Consent.AcceptAndSign')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConsentDialog.propTypes = {
  open: bool.isRequired,
  documentName: string.isRequired,
  onAccept: func.isRequired,
  onBack: func.isRequired,
};

export default ConsentDialog;
